export const menuLinks = [
/*    {
        label: 'Feeds',
        items: [
            {
                label: 'Home',
                icon: 'pi pi-home',
                route: '/home',
            },
            {
                label: 'Feeds',
                icon: 'pi pi-database',
                route: '/feeds',
            },
            {
                label: 'Setup',
                icon: 'pi pi-compass',
                route: '/feed/setup',
            },
            {
                label: 'Setup',
                icon: 'pi pi-cog',
                route: '/feed/setup',
            },
        ],
    },*/
];